import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';
import { ModalID } from '../../models/constants';

@Component({
  selector: 'app-create-form-3310',
  standalone: true,
  templateUrl: './create-form-3310.component.html',
  styleUrl: './create-form-3310.component.scss',
  imports: [FormsModule],
})
export class CreateForm3310Component {
  local_authority_name: string
  local_authority_email: string
  atf_email: string
  
  constructor(private sharedService: SharedService) {}
  ngOnInit() {
    this.local_authority_name = JSON.parse(JSON.stringify(this.sharedService.company_info.autofill_form_3310.agency_name));
    this.local_authority_email = JSON.parse(JSON.stringify(this.sharedService.company_info.autofill_form_3310.agency_email));
    this.atf_email = JSON.parse(JSON.stringify(this.sharedService.company_info.autofill_form_3310.atf_email));
  }
  reviewForm3310() {}
  emailForm3310() {}
  closeModalClick() {
    this.sharedService.closeModal(ModalID.create_form_3310);
  }
}
